import { TokenIconNameAliases } from './token/aliases.es.js';

const IconNameAliases = {
    ...TokenIconNameAliases
};

export { IconNameAliases };
//# sourceMappingURL=aliases.es.js.map
